import {useFormikContext} from 'formik'
import {useState} from 'react'
import {InlineTable} from 'src/feature/bite/component'
import * as Yup from 'yup'

export default function ProfessionalDetails({
  loading,
  intl,
  editable,
  setEditable,
}: {
  loading: boolean
  intl: any
  editable: any
  setEditable: any
}) {
  const {handleSubmit, values, resetForm, initialValues} = useFormikContext() as any

  const column = [
    [
      {
        title: 'Qualifications',
        key: 'qualifications',
        dataIndex: 'qualifications',
        edit: 'textarea',
        maxLength: 1001,
        tooltip: 'List any academic or professional qualifications relevant to your field.',
      },

      {
        title: 'Certificates',
        key: 'certificates',
        dataIndex: 'certificates',
        edit: 'textarea',
        maxLength: 1001,
        tooltip: 'Add certifications that validate your skills and expertise.',
      },
      {
        title: 'Conferences Attended',
        key: 'conferencesAttended',
        dataIndex: 'conferencesAttended',
        edit: 'textarea',
        maxLength: 1001,
        tooltip:
          'Detail any industry conferences, workshops, or seminars you have participated in.',
      },
    ],
    [
      {
        title: 'Education',
        key: 'education',
        dataIndex: 'education',
        edit: 'textarea',
        maxLength: 1001,
        tooltip: 'Provide details about your educational background.',
      },
      {
        title: 'Experience',
        key: 'experience',
        dataIndex: 'experience',
        edit: 'textarea',
        maxLength: 1001,
        tooltip:
          'Describe your work experience, including past roles and duration in the industry.',
      },
      {
        title: 'Memberships',
        key: 'memberships',
        dataIndex: 'memberships',
        maxLength: 1001,
        edit: 'textarea',
        tooltip: 'Mention any professional associations or organizations you are a member of.',
      },
    ],
  ]

  const validationSchema = Yup.object().shape({})

  return (
    <div className='card mb-5 mb-xl-10' id='kt_profile_details_view'>
      <div className='card-header'>
        <div className='card-title m-0 d-flex justify-content-between w-100'>
          <div>
            <h3 className='fw-bold mb-2 mt-5'>
              {intl.formatMessage({id: 'PROVIDER.PROFESSIONAL_DETAILS'})}
            </h3>
            <p className='text-muted fw-normal fs-6'>
              Provide information about your qualifications, experience, and memberships to showcase
              your expertise. <br />
              Use a semicolon (;) to separate multiple entries.The information entered in this
              section will be shown to users through your Vasco Life App profile.
            </p>
          </div>
        </div>
      </div>
      <div className='card-body p-9'>
        <InlineTable
          loading={loading}
          dataSource={initialValues}
          columns={column}
          editable={editable.professionalDetails}
          values={values}
        />
      </div>
      <div className='card-footer d-flex w-100 justify-content-end'>
        {editable.professionalDetails ? (
          <div>
            <button
              className='btn btn-primary'
              style={{marginRight: 10}}
              onClick={() => {
                setEditable({
                  overview: false,
                  professionalDetails: false,
                  serviceDetails: false,
                  socialMedia: false,
                  contractDetails: false,
                  financialDetails: false,
                })
                resetForm()
              }}
            >
              <i className='bi bi-x me-2'></i>
              {intl.formatMessage({id: 'GLOBAL.BUTTON.CANCEL'})}
            </button>
            <button
              className='btn btn-primary'
              disabled={loading}
              type='button'
              onClick={async () => {
                values.type = 1
                await handleSubmit()
              }}
            >
              <i className='bi bi-save2 me-2'></i>
              {loading
                ? intl.formatMessage({id: 'GLOBAL.BUTTON.SAVING'})
                : intl.formatMessage({id: 'GLOBAL.BUTTON.SAVE'})}
            </button>
          </div>
        ) : (
          <button
            className='btn btn-primary'
            onClick={() => {
              resetForm()
              setEditable({
                overview: false,
                professionalDetails: true,
                serviceDetails: false,
                socialMedia: false,
                contractDetails: false,
                financialDetails: false,
              })
            }}
          >
            <i className='bi bi-pencil me-2'></i>
            {intl.formatMessage({id: 'GLOBAL.BUTTON.EDIT'})}
          </button>
        )}
      </div>
    </div>
  )
}
